import Cookies from "universal-cookie";
import {__isAvailable} from "./utility.helper";
import {urlHelper} from "./url.helper";

export const cookieHelper = {
	getStorageData,
	saveStorageData,
	removeStorageData,
};

/**
 * This function gets the user from authentication storage
 */
function getStorageData(identifier){
	return new Cookies().get(identifier);
}

/**
 * This function saves the given identifier and data to storage
 */
function saveStorageData(identifier, data){
	const options = getCookieOptions();
	new Cookies().set(identifier, JSON.stringify(data), options);
}

/**
 * Prepares cookie options based on url
 * @returns {{path: string}}
 */
function getCookieOptions() {
	const urlState = urlHelper.checkUrlDomain(window.location.href);
	let options = { path: "/" } // default fallback
	
	const isDomainAndTldAvailable = (fragments) => fragments !== null && fragments.domain !== null && fragments.tld !== null;
	const isNgrokUrl = (fragments) => isDomainAndTldAvailable(fragments) && fragments.domain === "ngrok"
	
	// Necessary conditions to be met: 1. domain based url 2. domain & tld available 3. not a ngrok url
	if (!urlState.isLocalOrIp && isDomainAndTldAvailable(urlState.fragments) && !isNgrokUrl(urlState.fragments)) {
		options = {
			path: "/",
			domain: "." + urlState.fragments.domain + "." + urlState.fragments.tld,     // .domain.tld (allow access for all subdomain)
		}
	}
	return options;
}

/**
 * This function removes the given identifier from storage
 */
function removeStorageData(identifier) {
	const options = getCookieOptions();
	return new Promise((resolve, reject) => {
		new Cookies().remove(identifier, options);          // remove the cookie
		
		// validate
		const identifierCookie = getStorageData(identifier);
		return __isAvailable(identifierCookie)
				? reject(new Error("Cookie [" + identifierCookie + "] still exist!"))
				: resolve({message: "Cookie [" + identifierCookie + "] was removed."})
	})
}